import axios from 'axios'
const RESOURCE_NAME_DELETE_COHORT = '/api/SurveyClientData/DeleteClientCohort'

export const CohortService = {
    DeleteCohort
};

function DeleteCohort(params, cb, errorCb) {
    axios
        .delete(RESOURCE_NAME_DELETE_COHORT +
                        '?productType=' + params.productType + '&'
                        + 'clientID=' + params.clientId + '&'
                        + 'userid=' + params.userid + '&'
                        + 'moduleId=' + params.moduleId + '&'
                        + 'userSettingId=' + params.userSettingId + '&'
                        + 'updatedBy=' + params.updatedBy
        )
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}
